ch-tabular-grid {
  --indent: 16px;
}
